// ** Redux, Thunk & Root Reducer Imports
import thunk, { ThunkDispatch, ThunkMiddleware } from 'redux-thunk'
// @ts-ignore
import createDebounce from 'redux-debounced'
import rootReducer from '../reducers/rootReducer'
import { createStore, applyMiddleware, compose, Store, AnyAction } from 'redux'
import * as Sentry from '@sentry/react'

// ** Define RootState type from rootReducer
export type RootState = ReturnType<typeof rootReducer>

// Add a store type that includes thunk-aware dispatch
type StoreWithThunk = Store<RootState, AnyAction> & {
  dispatch: ThunkDispatch<RootState, unknown, AnyAction>;
}

// ** init middleware
const middleware = [thunk as ThunkMiddleware<RootState, AnyAction>, createDebounce()]

// ** Create Sentry Redux enhancer
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options here
})

// ** Dev Tools
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// ** Create store (cast to StoreWithThunk so dispatch accepts thunks)
const store = createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(...middleware), sentryReduxEnhancer)
) as StoreWithThunk

// Optional: export AppDispatch type for useDispatch<AppDispatch>() in components
export type AppDispatch = typeof store.dispatch

export { store }